import Analytics from '@justgiving/koala-front-end-analytics';
import { KOALA_API_URI } from 'config';
import log from 'src/logging';

export default ({ getState }) => next => action => {
  if (action.meta && action.meta.analytics) {
    const event = enhance(getState(), action.meta.analytics);
    track(event);
  }

  next(action);
};

function enhance(state, event) {
  let enhancedEvent = {
    page_type: 'crowdfunding page',
    ...event,
  };

  if (enhancedEvent.social_type) {
    enhancedEvent = {
      ...enhancedEvent,
      event: 'click',
      subtype: enhancedEvent.subtype || 'share',
      social_id: '',
      social_email: '',
      activity_type: 'crowdfunding_guid',
      actor_source: 'ownerUserId',
    };
  }

  if (state.page && state.page.id) {
    const page = state.page;

    if (enhancedEvent.content_type) {
      enhancedEvent.content_id = page.id || '';
    }

    if (enhancedEvent.activity_type) {
      enhancedEvent.activity_id = page.id || '';
    }

    if (enhancedEvent.actor_source) {
      enhancedEvent.actor_id = page.ownerUserId || '';
    }
  }

  return enhancedEvent;
}

function track(event) {
  trackKoala(event);
}

async function trackKoala(trackedInfo) {
  const analytics = getKoalaClient();

  try {
    await analytics.track({ ...trackedInfo });
  } catch (err) {
    log.warn(
      err,
      `Could not send event '${trackedInfo.event}/${
        trackedInfo.subtype
      }' to Koala`
    );
  }
}

let clientAnalytics;

function getKoalaClient() {
  if (__CLIENT__) {
    if (!clientAnalytics) {
      clientAnalytics = new Analytics({ apiUrl: KOALA_API_URI });
    }

    return clientAnalytics;
  }

  if (__SERVER__) {
    const requestStorage = require('../../server/requestStorage').default;

    return requestStorage.get('analytics');
  }

  throw new Error('Koala not supported in current env');
}



// WEBPACK FOOTER //
// ./src/redux/middleware/analytics.js